import React, { useState, useEffect } from 'react';
import { Menu, X, Lock } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

// Logo-Pfad: Die Datei liegt in /app/frontend/public/img/logo_gross.png
const LOGO_SRC = '/img/logo_gross.png';

const nav = [
  { label: 'Start', href: '/#top' },
  { label: "So funktioniert's", href: '/#workflow' },
  { label: 'Funktionen', href: '/#features' },
  { label: 'How To', href: '/howto' },
  { label: 'FAQ', href: '/#faq' },
  { label: 'Über uns', href: '/#team' },
  { label: 'Kontakt', href: '/#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [logoOk, setLogoOk] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleAnchorClick = (e, href) => {
    if (href.startsWith('/#') && location.pathname === '/') {
      e.preventDefault();
      const id = href.split('#')[1];
      const el = document.getElementById(id);
      if (el) {
        window.scrollTo({ top: el.offsetTop - 70, behavior: 'smooth' });
        setOpen(false);
      }
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur shadow-md py-2'
          : 'bg-spin-dark/30 backdrop-blur-sm py-3'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" onClick={() => window.scrollTo({ top: 0 })}>
          {logoOk ? (
            <img
              src={LOGO_SRC}
              alt="Spinsafe"
              className="h-11 w-auto"
              onError={() => setLogoOk(false)}
            />
          ) : (
            <>
              <span
                className={`w-9 h-9 rounded-md flex items-center justify-center transition-colors ${
                  scrolled ? 'bg-spin-green text-white' : 'bg-white/95 text-spin-green'
                }`}
              >
                <Lock size={18} strokeWidth={2.4} />
              </span>
              <span
                className={`font-heading font-bold text-xl tracking-tight transition-colors ${
                  scrolled ? 'text-spin-dark' : 'text-white'
                }`}
              >
                spinsafe
              </span>
            </>
          )}
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {nav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => handleAnchorClick(e, item.href)}
              className={`text-sm font-semibold uppercase tracking-wide transition-colors hover:text-spin-green-light ${
                scrolled ? 'text-spin-dark' : 'text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className={`lg:hidden p-2 ${scrolled ? 'text-spin-dark' : 'text-white'}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-border shadow-lg">
          <div className="max-w-6xl mx-auto px-5 py-3 flex flex-col gap-1">
            {nav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleAnchorClick(e, item.href)}
                className="py-3 text-sm font-semibold uppercase tracking-wide text-spin-dark border-b border-border last:border-b-0"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
